import React, { FC, VFC, useEffect, useState } from 'react';
import { ReactComponent as PetDog } from '@/assets/img/pet-dog-default-icon.svg';
import { ReactComponent as PetCat } from '@/assets/img/pet-cat-default.svg';
import './BoardingPetInfo.scss';
import { Dropdown } from 'react-bootstrap';
import { PetInfoDropDownItem } from './PetInfoDropDownItem';
import { Pets } from '@/features/customers';
type BoardingPetInfoProps = {
  data?: Pets[];
  accomodationType?: string;
};
const BoardingPetInfo = ({ data, accomodationType }: BoardingPetInfoProps) => {
  return (
    <div className={`pet-boarding-info`}>
      <div className="pet-profile">
        {data?.map(
          (pet, index) =>
            index < 2 && (
              <span className="pet-icon-bg">
                {pet?.petsImageUrl ? (
                  <img src={pet?.petsImageUrl} alt="pet icon" />
                ) : pet?.petType?.toLowerCase() == 'cat' ? (
                  <PetCat />
                ) : (
                  <PetDog />
                )}
              </span>
            )
        )}
      </div>
      <div className="pet-details">
        {data?.length && data.length == 1 ? (
          <p className="pet-name">{data[0].name}</p>
        ) : data && data?.length > 1 ? (
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic" className="dots-3-icon">
              <p className="total-pets">{data?.length} pet bookings</p>
            </Dropdown.Toggle>
            <Dropdown.Menu
              popperConfig={{
                strategy: 'fixed',
              }}
              renderOnMount
              className="border-2 dark:border-gray-800"
            >
              {data?.map((pet: any) => (
                <Dropdown.Item>
                  <PetInfoDropDownItem data={pet} />
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <></>
        )}
        <div className="accomodation-type">{accomodationType}</div>
      </div>
    </div>
  );
};
export default BoardingPetInfo;
